<div style="background-color: #F5F7F8; height: 92vh; overflow-y: hidden; padding: 7px; overflow-x: hidden;">
  <div style="height: 12vh;">
    <div class="row" style="width: 100%; margin: auto; margin-top: 20px; max-height: 116px;">
      <img style="margin-left: 10px; padding: 0px; width: 25px; height: 25px;" (click)="this.back()" src="/assets/images/shared/back.svg">
      <h2 class="col-9" style="position: relative; top: -3px; text-align: center; min-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; margin-bottom: 0px;">{{ this.title }}</h2>
      <button class="col-1" (click)="this.isSearchEnabled = true; this.main()" style="padding: 0px; padding-bottom: 10px; background-color: transparent; height: 40px; border: none;" type="button">
        <img src="/assets/images/categories/icon-search.svg" alt="">
      </button>

      <div *ngIf="this.isSearchEnabled" class="col-10" style="padding-right: 0px;">
        <div class="input-group">
          <span style="border: none; background-color: white;" class="input-group-text" id="basic-addon1"><i class="bi bi-search"></i></span>
          <input
            (focus)="this.shouldFiltersBevisible = false"
            (blur)="this.shouldFiltersBevisible = true; this.isSearchEnabled = false"
            (keyup.enter)="this.initiateSearch()"
            style="height: 38px; border: none; border-top-right-radius: 0.25em; border-bottom-right-radius: 0.25em;"
            type="text"
            #search
            class="form-control"
            formControlName="newPassword"
            (change)="this.onSearchTextChange($event)"
            [placeholder]="this.pageDetails().search"
            [value]="this.searchedText || ''"
            aria-label="Username"
            aria-describedby="basic-addon1"
          >
          <button *ngIf="this.searchedText" (click)="this.clearSeacrhedText()" type="button" class="btn bg-transparent" style="margin-left: -35px; z-index: 100;">
            <i class="fa fa-times" style="content: url('/assets/images/home/cross.svg');"></i>
          </button>
        </div>
      </div>
    </div>

    <hr style="width: 90%; margin: auto; border: 1px solid #F1F3F5; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

    <div *ngIf="this.shouldFiltersBevisible" style="width: 95%; margin: auto; margin-top: 10px; margin-bottom: 10px;">
      <button (click)="open(order)" style="width: fit-content; height: 40px; border-radius: 7px; padding: 10px; border: none; background-color: white;" type="button">
        {{ this.selectedOrder }} &nbsp;<i class="bi bi-caret-down-fill" style="position: relative; top: 2px;"></i>
      </button>

      <button style="margin-left: 10px; width: 40px; height: 40px; padding: 5px; border: none; background-color: white; float: right; border-radius: 7px;" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="offcanvasExample">
        <img src="/assets/images/home/icon-filter.svg" alt="">
      </button>

      <button (click)="this.toggleViewType()" style="width: 40px; height: 40px; padding: 5px; border: none; background-color: white; float: right; border-radius: 7px;" type="button">
        <img [src]="this.viewTypeIcon" alt="">
      </button>
    </div>
  </div>

  <div style="margin-top: 10px;">
    <div
      *ngIf="this.ds && !this.ds!.productsLength && !this.ds!.loading && this.ds2 && !this.ds2!.productsLength && !this.ds2!.loading"
      style="text-align: center; display: grid; justify-content: center; width: 100%; align-content: center;"
    >
      <img src="/assets/images/home/nothing-found.svg" alt="" style="margin: auto; display: block; margin-top: 20px; margin-bottom: 20px;">
      <h4 style="width: 90%; text-align: center; font-weight: 600; margin: auto; margin-top: 10px;">0 резултата за "{{this.searchedText}}"</h4>
      <p style="width: 90%; text-align: center; color: #ADAFBB; margin: auto; margin-top: 10px;">
        Провери дали думата, която търсиш е правилно изписана или опитай с друга дума
      </p>
    </div>

    <cdk-virtual-scroll-viewport *ngIf="this.viewType == productViewTypes.list" [itemSize]="165" class="example-viewport" style="height: 75vh; overflow-x: hidden; width: 100%;">
      <div
        *cdkVirtualFor="let item of ds; index as i; templateCacheSize: 0"
        [class]="this.viewType == productViewTypes.list ? 'example-item col-12' : 'example-item col-6'"
        [style]="this.viewType == productViewTypes.list ? 'height: 165px;' : ((i % 2 == 0) ? 'height: 320px; padding-right: 4.5px' : 'height: 320px; padding-left: 4.5px')"
      >
        <div *ngIf="item && this.viewType == productViewTypes.list" style="height: 165px;">
          <div [matBadge]="item.is_in_group ? 'Групова поръчка' : ''" matBadgeColor="warn" matBadgePosition="before" (click)="this.openItem(item.uuid, 'none')" class="card mb-3" style="border: unset; max-width: 540px; padding: 10px; background-color: white; border-radius: 9px;">
            <div class="row">
              <div class="col-4">
                <img [src]="item.imageURL" class="card-img img-fluid" style="height: 120px;" alt="...">
              </div>

              <div class="col-8" style="padding: 0px; padding-right: 5px;">
                <p style="margin-bottom: 5px; display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 63px; overflow: hidden; text-overflow: ellipsis; margin-top: 5px;">
                  {{ item?.name || '' }}
                </p>

                <ngb-rating style="position: relative;" [readonly]="true" [max]="5" [(rate)]="item.ratingAvgValue!">
                  <ng-template let-fill="fill" let-index="index">
                    <i class="bi-star{{fill === 100 ? '-fill  filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                  </ng-template>
                </ngb-rating>
                <span style="color: #b0c4de; font-size: 10px;">{{ ' (' + item.ratings!.data.length  + ')' }}</span>

                <div *ngIf="hasProductPrice(item)" style="font-weight: 700; margin-top: 5px;">
                  <app-price
                    class="category-card-price"
                    [amount]="getProductCardBasePrice(item)"
                    layout="inline"
                  ></app-price>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>

    <cdk-virtual-scroll-viewport *ngIf="this.viewType == productViewTypes.grid" [itemSize]="320" class="example-viewport" style="height: 75vh; overflow-x: hidden; width: 100%;">
      <div *cdkVirtualFor="let item of ds2; index as i; templateCacheSize: 0" class="example-item col-12" [style]="this.viewType == productViewTypes.list ? 'height: 165px;' : 'height: 320px;'">
        <div class="row">
          <div *ngFor="let rowItem of item; index as i" class="col-6" [style]="this.viewType == productViewTypes.list ? 'height: 165px;' : ((i % 2 == 0) ? 'height: 320px; padding-right: 3.5px' : 'height: 320px; padding-left: 3.5px')">
            <div *ngIf="rowItem && this.viewType == productViewTypes.grid" style="height: 320px">
              <div [matBadge]="rowItem.is_in_group ? 'Групова поръчка' : ''" matBadgeColor="warn" matBadgePosition="before" (click)="this.openItem(rowItem.uuid, 'none')" class="card mb-3" style="min-height: 290px; border: unset; padding: 10px; background-color: white; border-radius: 9px;">
                <div class="row">
                  <div class="col-12">
                    <img [src]="rowItem.imageURL" class="card-img img-fluid" style="height: 165px;" alt="...">
                  </div>

                  <div class="col-12" style="text-align: center;">
                    <p style="margin-bottom: 5px; display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 63px; overflow: hidden; text-overflow: ellipsis; margin-top: 5px;">
                      {{ rowItem?.name || '' }}
                    </p>

                    <ngb-rating style="position: relative;" [readonly]="true" [max]="5" [(rate)]="rowItem.ratingAvgValue!">
                      <ng-template let-fill="fill" let-index="index">
                        <i class="bi-star{{fill === 100 ? '-fill  filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                      </ng-template>
                    </ngb-rating>
                    <span style="color: #b0c4de; font-size: 10px;">{{ ' (' + rowItem.ratings!.data.length  + ')' }}</span>

                    <div *ngIf="hasProductPrice(rowItem)" style="font-weight: 700; margin-top: 5px; font-size: 16px;">
                      <app-price
                        class="category-card-price category-card-price--grid"
                        [amount]="getProductCardBasePrice(rowItem)"
                        layout="inline"
                      ></app-price>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>

<div style="width: 80vw;" class="offcanvas offcanvas-end"  tabindex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header" style="height: 5vh;">
    <h3 class="offcanvas-title" id="staticBackdropLabel" style="margin-top: 20px; font-weight: 600;">Филтри</h3>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body" style="height: 85vh;">

    <div *ngIf="this.category">
      <p style="font-weight: 700;">Цена</p>
      <div style="width: 90%; margin: auto;" *ngIf="this.options.ceil">
        <ngx-slider [(value)]="this.minValue" [(highValue)]="this.maxValue" [options]="this.options"></ngx-slider>
      </div>
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
    </div>

    <p style="font-weight: 700; margin: 0 0 15px;" (click)="this.openCategories(categories)">{{ this.selectedFilterCategory || 'Категория' }}<span style="color: #ADAFBB; float: right; font-weight: normal;">Избери <img src="/assets/images/shared/arrow.svg" style="height: 15px; width: 15px;"></span></p>

    <div *ngIf="this.availableFilterOptions.length">
      <div *ngFor="let option of this.availableFilterOptions">
        <div *ngIf="option.key == 'Пол'">
          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
          <div *ngIf="this.isAreaExpanded(option.key)">
            <p style="font-weight: 700;">{{ option.key }} </p>
            <div class="form-check" *ngFor="let value of option.value">
              <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="value.value" [id]="option.key + '-' + value.value">
              <label class="form-check-label" [for]="option.key + '-' + value.value">
                {{value.text}}
              </label>
            </div>
            <p style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, false)">Скрий</p>  
         </div>
          <div *ngIf="!this.isAreaExpanded(option.key)">
            <p style="font-weight: 700;">{{ option.key }} </p>
            <div class="form-check" *ngFor="let value of this.getFirstOptions(option.value); index as i">
              <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="value.value" [id]="option.key + '-' + value.value">
              <label class="form-check-label" [for]="option.key + '-' + value.value">
                {{value.text}}
              </label>
            </div>
            <p *ngIf="option.value.length > maxOptionsPerFilter" style="margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, true)">Виж всички</p>
          </div>
        </div>
      </div>
    </div>

    <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">

    <p style="font-weight: 700;">Безплатна доставка</p>
    <div class="form-check">
      <input (change)="this.delivery = undefined" [checked]="this.delivery === undefined" class="form-check-input" type="radio" name="delivery" id="delivery3">
      <label class="form-check-label" for="delivery3">
        Всички
      </label>
    </div>
    <div class="form-check">
      <input (change)="this.delivery = true" [checked]="this.delivery === true" class="form-check-input" type="radio" name="delivery" id="delivery1">
      <label class="form-check-label" for="delivery1">
        Да
      </label>
    </div>
    <div class="form-check">
      <input (change)="this.delivery = false" [checked]="this.delivery === false" class="form-check-input" type="radio" name="delivery" id="delivery2" checked>
      <label class="form-check-label" for="delivery2">
        Не
      </label>
    </div>
    <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">

    <p style="font-weight: 700;">Група </p>
    <div class="form-check">
      <input (change)="this.group = undefined" [checked]="this.group === undefined" class="form-check-input" type="radio" name="group" id="group3">
      <label class="form-check-label" for="group3">
        Всички
      </label>
    </div>
    <div class="form-check">
      <input (change)="this.group = true"  [checked]="this.group === true" class="form-check-input" type="radio" name="group" id="group1">
      <label class="form-check-label" for="group1">
        Да
      </label>
    </div>
    <div class="form-check">
      <input (change)="this.group = false" [checked]="this.group === false" class="form-check-input" type="radio" name="group" id="group2" checked>
      <label class="form-check-label" for="group2">
        Не
      </label>
    </div>
    <div *ngIf="this.areAvailableFiltersSet && this.isAreaExpanded('brands')">
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
      <p style="font-weight: 700;">Марка </p>
      <div class="form-check" *ngFor="let brand of this.availableFilterBrands">
        <input (change)="this.brandUpdated($event)" [checked]="this.shouldBrandBeChecked(brand.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="brand.value" [id]="brand.value">
        <label class="form-check-label" [for]="brand.value">
          {{brand.key}}
        </label>
      </div>
      <p style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('brands', false)">Скрий</p>
    </div>

    <div *ngIf="this.areAvailableFiltersSet && !this.isAreaExpanded('brands')">
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
      <p style="font-weight: 700;">Марка </p>
      <div class="form-check" *ngFor="let brand of this.getFirst(this.availableFilterBrands); index as i;">
        <input (change)="this.brandUpdated($event)" [checked]="this.shouldBrandBeChecked(brand.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="brand.value" [id]="brand.value">
        <label class="form-check-label" [for]="brand.value">
          {{brand.key}}
        </label>
      </div>
      <p *ngIf="this.availableFilterBrands.length > maxOptionsPerFilter" style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('brands', true)">Виж всички</p>
    </div>

    <div *ngIf="this.areAvailableFiltersSet && this.isAreaExpanded('partners')">
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
      <p style="font-weight: 700;">Партньори </p>
      <div class="form-check" *ngFor="let partner of this.availableFilterPartners">
        <input (change)="this.partnerUpdated($event)" [checked]="this.shouldPartnerBeChecked(partner.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="partner.value" [id]="partner.value">
        <label class="form-check-label" [for]="partner.value">
          {{partner.key}}
        </label>
      </div>
      <p  style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('partners', false)">Скрий</p>
    </div>

    <div *ngIf="this.areAvailableFiltersSet && !this.isAreaExpanded('partners')">
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
      <p style="font-weight: 700;">Партньори </p>
      <div class="form-check" *ngFor="let partner of this.getFirst(this.availableFilterPartners); index as i;">
        <input (change)="this.partnerUpdated($event)" [checked]="this.shouldPartnerBeChecked(partner.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="partner.value" [id]="partner.value">
        <label class="form-check-label" [for]="partner.value">
          {{partner.key}}
        </label>
      </div>
      <p *ngIf="this.availableFilterPartners.length > maxOptionsPerFilter" style="margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('partners', true)">Виж всички</p>
    </div>



    <div *ngIf="this.availableFilterOptions.length">
      <div *ngFor="let option of this.availableFilterOptions">
        <div *ngIf="option.key != 'Пол'">
          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
          <div *ngIf="this.isAreaExpanded(option.key)">
            <p style="font-weight: 700;">{{ option.key }} </p>
            <div class="form-check" *ngFor="let value of option.value.values">
              <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name) " style="position: relative; top: -1px;" class="form-check-input" [type]="option.value.type == 'radio' ? 'radio' : 'checkbox'" [value]="value.value" [id]="option.key + '-' + value.text">
              <label class="form-check-label" [for]="option.key + '-' + value.text"  [style]="option.key == 'Цвят' ? 'position: relative; top: -4px;' : ''">
                <span *ngIf="option.key == 'Цвят'"> <img *ngIf="value.text.includes('Многоцветен')" style="display: inline-block;height: 20px;width: 20px;position: relative; top: 5px;"  src="/assets/images/product/colorful.svg" alt=""><span *ngIf="!value.text.includes('Многоцветен')" [style]="(!value.text.includes('Бял')) ? 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; background-color: '+ this.getColor(value.text) : 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; border: 1px solid black'"></span></span>
                {{value.text}} 
              </label>
            </div>
            <p style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, false)">Скрий</p>

          </div>
          <div *ngIf="!this.isAreaExpanded(option.key)">
            <p style="font-weight: 700;">{{ option.key }} </p>
            <div class="form-check" *ngFor="let value of this.getFirstOptions(option.value); index as i">
              <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name)" style="position: relative; top: -1px;" class="form-check-input" [type]="option.value.type == 'radio' ? 'radio' : 'checkbox'" [value]="value.value" [id]="option.key + '-' + value.text">
              <label class="form-check-label" [for]="option.key + '-' + value.text" [style]="option.key == 'Цвят' ? 'position: relative; top: -4px;' : ''">
               <span *ngIf="option.key == 'Цвят'"> <img *ngIf="value.text.includes('Многоцветен')" style="display: inline-block;height: 20px;width: 20px;position: relative; top: 5px;"  src="/assets/images/product/colorful.svg" alt=""><span *ngIf="!value.text.includes('Многоцветен')" [style]="(!value.text.includes('Бял')) ? 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; background-color: '+ this.getColor(value.text) : 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; border: 1px solid black'"></span></span>
               {{value.text}} 
              </label>
            </div>
          <p *ngIf="option.value.values.length > maxOptionsPerFilter" style="margin-top: 7px; color: #0A69EB;" (mousedown)="this.setExpandedArea(option.key, true)">Виж всички</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="height: 10vh;">
    <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 5px;">
    <div class="row justify-content-around">
      <button type="button" class="btn btn-primary col-4" style="width: 90%; margin: auto; background-color: #E4F2FE; color: #0A69EB;" (click)="this.clear()">Изчисти</button>
      <button  data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="offcanvasExample" type="button" class="btn btn-primary col-4" style="width: 90%; margin: auto;" (click)="this.filter()">Филтрирай</button>
    </div>
  </div>
</div>

<ng-template #order let-modal>
  <div style="padding-top: 10px !important; padding-bottom: 10px !important;">
    <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">Подреди по:</h3>
    <!-- <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
    <div style="width: 100%;">
      <ul class="list-group list-group-flush" style="width: 80%; margin: auto; list-style-type: none;">
        <li style="position: relative; top: -5px;"  (click)="this.selectOrder('rating', 'rate', modal)" [id]="this.selectedOrder == 'Най-популярни' ? 'active' : ''"> Най-популярни</li>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <li style="position: relative; top: -5px;" (click)="this.selectOrder('newest', 'new', modal)" [id]="this.selectedOrder == 'Най-нови' ? 'active' : ''">Най-нови</li>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <li style="position: relative; top: -5px;" (click)="this.selectOrder('price', 'price', modal)" [id]="this.selectedOrder == 'Най-ниска цена' ? 'active' : ''">Най-ниска цена</li>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <li style="position: relative; top: -5px;" (click)="this.selectOrder('-price', 'maxprice', modal)" [id]="this.selectedOrder == 'Най-висока цена' ? 'active' : ''">Най-висока цена</li>
      </ul>
    </div>
  </div>
</ng-template>


<ng-template #categories let-modal>
  <ul class="list-group">
    <li class="list-group-item" (click)="this.selectCategory('', modal)">Изчисти</li>
    <li class="list-group-item" (click)="this.selectCategory(category.uuid, modal)" *ngFor="let category of this.filterCategories.data">{{category.name}}</li>
  </ul>
</ng-template>
